import { render, staticRenderFns } from "./sp.vue?vue&type=template&id=7c0a6367"
import script from "./sp.vue?vue&type=script&lang=ts"
export * from "./sp.vue?vue&type=script&lang=ts"
import style0 from "./sp.vue?vue&type=style&index=0&id=7c0a6367&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports